import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { assetService } from "src/core/services/assetService";
import { viewService } from "src/core/services/viewService";
import { ClientMode } from "../../../../../../core/backend/clients/backendClient";
import { Login } from "../../../../../auth/components/Login/Login";
import { useSettingsStore } from "../../../../../settings/services/useSettingsStore";
import { LandingContact } from "../LandingContact/LandingContact";
import "./LandingTop.css";

function LandingTop() {
  const settingsStore = useSettingsStore();
  const { t } = useTranslation();

  const navigate = useNavigate();

  const loginOverlay = useRef<OverlayPanel | null>(null);

  const isMobileSize = viewService.isMobileSize;
  const isMaganMode =
    settingsStore.clientConfiguration.mode === ClientMode.Magan;

  const hideLogin =
    settingsStore.clientConfiguration.subMode?.includes("hidelogin");

  return (
    <div className="landingTop">
      <div
        className="grid p-0"
        style={{
          backgroundColor: isMaganMode ? "transparent" : "var(--primary-color)",
        }}
      >
        <div className="col-12 md:col-6 p-0 flex-order-1 md:flex-order-0">
          <img
            src={assetService.getImagePath("landing_top.png")}
            alt=""
            className={
              "img block" +
              (isMaganMode ? " mb-3 border-round-xl shadow-8" : "")
            }
          />

          {isMobileSize && <LandingContact />}
        </div>
        <div className="col-12 md:col-6 p-0 flex flex-order-0 md:flex-order-1">
          <div className="content-div-shared flex flex-column">
            <h2 className="title">{t("Home.EK.Title")}</h2>

            <span className="text">{t("Home.EK.Description")}</span>

            <div className="box flex flex-column gap-1 md:mt-5 w100">
              <div>
                {isMaganMode && (
                  <Button
                    className="login-button p-0 mt-1 mb-1 w100 shadow-5"
                    onClick={() => {
                      navigate("/appointment");
                    }}
                  >
                    <div className="flex flex-column justify-content-center gap-1 w100">
                      <span className="font-bold">
                        {t("Home.Appointments.Title").toUpperCase()}
                      </span>
                      <span className="text-base">
                        {t("Home.Appointments.SubTitle")}
                      </span>
                    </div>
                  </Button>
                )}
              </div>
              <div className="mb-4">
                {!hideLogin && (
                  <Button
                    className="login-button p-0 mt-1 mb-1 w100 shadow-5"
                    onClick={(event) => {
                      loginOverlay.current?.toggle(event);
                    }}
                  >
                    <div className="flex flex-column justify-content-center gap-1 w100">
                      <span className="font-bold">
                        {t("Home.Login.Title").toUpperCase()}
                      </span>
                      <span className="text-base">
                        {t("Home.Login.SubTitle")}
                      </span>
                    </div>
                  </Button>
                )}
              </div>

              {!isMobileSize && <LandingContact />}
            </div>
          </div>
          {!isMaganMode && (
            <div className="side-div flex flex-column">
              <div className="side-div-child1"></div>
              <div className="side-div-child2"></div>
            </div>
          )}
        </div>
      </div>

      <OverlayPanel
        ref={loginOverlay}
        dismissable={false}
        showCloseIcon
        style={{
          maxWidth: "350px",
          right: "10px",
        }}
      >
        <div className="p-overlaypanel-title">{t("Home.Login.Title")}</div>

        <Login
          registerVisible={true}
          forgotPasswordVisible={true}
          afterLogin={() => {
            navigate("/home");
          }}
        />
      </OverlayPanel>
    </div>
  );
}

export default LandingTop;
